const DEFAULT_TIMEOUT = 30 * 1000;
const ACCEPTABLE_TYPES = ['arrayBuffer', 'blob', 'json', 'text', 'formData'];

const StatusChecker = require('./status-checker');

const fetchExtra = (input, init = {}) => {
  const url = input instanceof Request ? input.url : input;
  const timeout = init.timeout || DEFAULT_TIMEOUT;
  const expectStatus = init.expectStatus;
  const expectType = init.expectType;

  const whenTimeout = new Promise((resolve, reject) => setTimeout(() => reject(new Error(`Timeout after ${timeout} ms.`)), timeout));
  const passthrough = x => x;

  const expectStatusHandler = response => {
    if (StatusChecker.hasMatch(response.status, expectStatus)) {
      return response;
    } else {
      throw new Error(`Unexpected status ${response.status}.`);
    }
  };

  const expectTypeHandler = response => {
    if (ACCEPTABLE_TYPES.indexOf(expectType) === -1) {
      throw new Error(`"${expectType}" is an invalid expected type.`);
    } else {
      return response[expectType]();
    }
  };

  return Promise.race([whatwg_fetch(input, init), whenTimeout])
    .then(expectStatus ? expectStatusHandler : passthrough)
    .then((expectStatus && expectType) ? expectTypeHandler : passthrough)
    .catch(e => {
      const error = new Error(`Error fetching "${url}". Reason: ${e.message}`);
      error.stack = e.stack;
      throw error;
    });
};
module.exports = fetchExtra;


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/fetch-extra.js